export class Duration {
    readonly milliseconds: number;
  
    constructor({
      years = 0,
      months = 0,
      weeks = 0,
      days = 0,
      hours = 0,
      minutes = 0,
      seconds = 0,
      milliseconds = 0,
    }: {
      years?: number;
      months?: number;
      weeks?: number;
      days?: number;
      hours?: number;
      minutes?: number;
      seconds?: number;
      milliseconds?: number;
    }) {
      this.milliseconds =
        ((((years * 365 + months * 30 + weeks * 7 + days) * 24 + hours) * 60 +
          minutes) *
          60 +
          seconds) *
          1000 +
        milliseconds;
    }
  
    static between(date1: Date, date2: Date): Duration {
      return Duration.fromMilliseconds(Math.abs(date2.getTime() - date1.getTime()));
    }
  
    static fromMilliseconds(milliseconds: number) {
      return new Duration({ milliseconds });
    }
  
    /**
     * Akıllı pattern bazlı formatlama
     * skipZero = true ise 0 olan birimler ve yanındaki metin gizlenir
     */
    formatPattern(pattern: string, skipZero: boolean = false): string {
      let remaining = this.milliseconds;
  
      const unitDefs: Record<string, number> = {
        yy: 1000 * 60 * 60 * 24 * 365,
        y: 1000 * 60 * 60 * 24 * 365,
        MM: 1000 * 60 * 60 * 24 * 30,
        M: 1000 * 60 * 60 * 24 * 30,
        ww: 1000 * 60 * 60 * 24 * 7,
        w: 1000 * 60 * 60 * 24 * 7,
        dd: 1000 * 60 * 60 * 24,
        d: 1000 * 60 * 60 * 24,
        hh: 1000 * 60 * 60,
        h: 1000 * 60 * 60,
        mm: 1000 * 60,
        m: 1000 * 60,
        ss: 1000,
        s: 1000,
        SSS: 1,
      };
  
      const values: Record<string, number> = {};
      for (const key of Object.keys(unitDefs)) {
        const value = Math.floor(remaining / unitDefs[key]);
        remaining -= value * unitDefs[key];
        values[key] = value;
      }
  
      // Akıllı replace
      const tokenRegex = /yy|y|MM|M|ww|w|dd|d|hh|h|mm|m|ss|s|SSS/g;
  
      let formatted = pattern.replace(tokenRegex, (token) => {
        const val = values[token];
        if (skipZero && val === 0) return "__REMOVE__"; // geçici işaret
        if (token === "SSS") return val.toString().padStart(3, "0");
        return token.length === 2 ? val.toString().padStart(2, "0") : val.toString();
      });
  
      // "__REMOVE__" ile işaretlenmiş kısımları ve yanındaki boşlukları temizle
      formatted = formatted.replace(/__REMOVE__(\s*[:\s]*)/g, "");
  
      // Gereksiz boşlukları temizle
      formatted = formatted.replace(/\s+/g, " ").trim();
  
      return formatted;
    }
  }
  